import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import ReactCountryFlag from "react-country-flag";
import { setCookie } from "../jwt/_helpers/cookie";
import { StateContext } from "../utils/context";

const languages = [
  { code: "en", label: "EN", countryCode: "GB" },
  { code: "de", label: "DE", countryCode: "DE" },
  { code: "it", label: "IT", countryCode: "IT" },
  { code: "es", label: "ES", countryCode: "ES" },
  { code: "fr", label: "FR", countryCode: "FR" },
  { code: "hr", label: "HR", countryCode: "HR" },
  { code: "nl", label: "NL", countryCode: "NL" },
  { code: "pt", label: "PT", countryCode: "PT" }
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const { language, setLanguage } = useContext(StateContext);

  const options = languages.map((lang) => ({
    value: lang.code,
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <ReactCountryFlag
          countryCode={lang.countryCode}
          svg
          style={{ width: "20px", height: "15px", borderRadius: "3px" }}
        />
        <strong>{lang.label}</strong>
      </div>
    )
  }));

  const [selectedLanguage, setSelectedLanguage] = useState(options.find((opt) => opt.value === i18n.language));

  const changeLanguage = (selectedOption) => {
    i18n.changeLanguage(selectedOption.value);
    setCookie("language", selectedOption.value);
    setLanguage(selectedOption.value);
    setSelectedLanguage(selectedOption);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minWidth: 80,
      padding: "2px",
      borderRadius: "8px",
      boxShadow: "none",
      borderColor: "#ccc",
      "&:hover": { borderColor: "#888" }
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "8px",
      padding: "5px",
      maxHeight: "none"
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "none",
      padding: 0
    }),
    option: (provided, state) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      padding: "10px",
      backgroundColor: state.isSelected ? "#ddd" : "#fff",
      color: "#333",
      "&:hover": { backgroundColor: "#f5f5f5" }
    })
  };

  return (
    <Select
      className="mt-2 mr-3"
      options={options}
      onChange={changeLanguage}
      value={selectedLanguage}
      isSearchable={false}
      styles={customStyles}
    />
  );
};

export default LanguageSwitcher;